module.exports = __webpack_public_path__ + "static/media/delegate.f9890550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/delegate.svg
// module id = 461
// module chunks = 0